import { configProduction, sharedFields } from './environmentsProd';

import type { Config } from './configType';

// Staging, Sandbox, Dev, Local envs

// Golden Config Staging v6
export const configStaging = {
  ...sharedFields,
  intercomId: 'upnml9ft', // Test
  env: 'staging',
  envIsSandbox: true,
  turnstileCaptchaSiteKey: '0x4AAAAAAALCW0bfNeRbnmZn',
  delegatedKeyExpirationDays: 16,
  chains: {
    // Faucet https://core.app/tools/testnet-faucet/?subnet=c&token=c
    avalanche: {
      chainNetwork: 'Avalanche-Fuji Testnet',
      chainBlockExplorer: 'https://testnet.avascan.info/blockchain/c',
      chainId: 43113,
      chainCurrency: 'AVAX',
      chainRpc: 'https://api.avax-test.network/ext/bc/C/rpc',
      chainRpcSoftwareWallet: true,
      depositNotAvailable: true,
      usdcTokenAddress: '0x89C1D24fFb34020a9Be5463bD2578fF966E9f303',
    },
    arbitrum: {
      chainNetwork: 'Arbitrum-Sepolia Testnet',
      chainBlockExplorer: 'https://sepolia.arbiscan.io',
      chainId: 421614,
      chainCurrency: 'ETH',
      chainRpc:
        'https://arb-sepolia.g.alchemy.com/v2/Mb9MWMHYaVtzPEzAmo_UCdUHdtRyrSvj', // 'https://arbitrum-sepolia.blockpi.network/v1/rpc/public',
      chainRpcSoftwareWallet: true,
      usdcTokenAddress: '0x3253a335E7bFfB4790Aa4C25C4250d206E9b9773',
      preferredChain: true,
    },
    baseEVM: {
      chainNetwork: 'Base-Sepolia Testnet',
      chainBlockExplorer: 'https://base.blockscout.com',
      chainId: 84532,
      chainCurrency: 'ETH',
      chainRpc:
        'https://base-sepolia.g.alchemy.com/v2/xAMyz0EAIKlYUXnQOW4xvXZeh0PVF5QB',
      chainRpcSoftwareWallet: true,
      averageBlockTimeSec: 2,
      depositPaused: true,
      usdcTokenAddress: undefined,
      preferredChain: true,
    },
    beraChain: {
      chainNetwork: 'cArtio (Bera) Testnet',
      chainBlockExplorer: 'https://80000.testnet.routescan.io',
      chainId: 80000,
      chainCurrency: 'BERA',
      chainRpc: 'https://teddilion-eth-cartio.berachain.com', // 'https://rockbeard-eth-cartio.berachain.com',
      chainRpcSoftwareWallet: true,
      averageBlockTimeSec: 2,
      // Alternative: Collateral (USDC OFTAdapter) cArtio L1	0xb1487b8C46e68e15ed3B01cC5AA4A1E6aFEfd6d4
      usdcTokenAddress: '0x015fd589F4f1A33ce4487E12714e1B15129c9329', // Collateral (USDC) cArtio L1
      preferredChain: true,
      depositNotAvailable: true, // On testnet we use Sepolia only
    },
    bnbSmartChain: {
      chainBlockExplorer: 'https://testnet.bscscan.com',
      chainId: 97,
      chainNetwork: 'BSC Testnet',
      chainCurrency: 'BNB',
      chainRpc: 'https://data-seed-prebsc-1-s1.binance.org:8545',
      chainRpcSoftwareWallet: true,
      depositNotAvailable: true,
      averageBlockTimeSec:
        configProduction.chains.bnbSmartChain.averageBlockTimeSec,
      usdcTokenAddress: undefined,
    },
    ethereum: {
      chainId: 11155111,
      chainNetwork: 'Eth-Sepolia Testnet',
      chainCurrency: 'ETH',
      chainRpc:
        'https://eth-sepolia.g.alchemy.com/v2/xAMyz0EAIKlYUXnQOW4xvXZeh0PVF5QB',
      chainRpcSoftwareWallet: true,
      chainBlockExplorer: 'https://sepolia.etherscan.io',
      usdcTokenAddress: '0x2F6F07CDcf3588944Bf4C42aC74ff24bF56e7590',
      preferredChain: true,
      depositNotAvailable: true,
      // devBgtRewardVaultAddress: '0x9694b8dD1E0a321FE2308Ab95AA0EEE6F741207a', // KRT Reward Vault on Sepolia
    },
    // https://bridge.katana.network/
    katanaChain: {
      chainId: 737373,
      chainNetwork: 'Katana Bokuto Testnet',
      chainCurrency: 'ETH',
      chainRpc: 'https://rpc-bokuto.katanarpc.com',
      chainRpcSoftwareWallet: true,
      chainBlockExplorer: 'https://explorer-bokuto.katanarpc.com',
      usdcTokenAddress: '0xc2a4C310F2512A17Ac0047cf871aCAed3E62bB4B',
      // usdcTokenSymbolOverride: 'vbUSDC',
      restApiUrl: 'https://api-staging.katana-perps-dev.com/v1',
      webSocketApiUrl: 'wss://websocket-staging.katana-perps-dev.com/v1',
      averageBlockTimeSec: 1,
      blocksConfirmation: 1,
      exchangeContract: '0x4C234fCeA3f8c4C8a7D962a6d8f2214f6ab1D5c4',
      stargateAdapterV3Address: '', // TODO: katana staging address
      stargateJumpChain: 'ethereum',
      stargateJumpChainForwarderAddress: '', // TODO: katana bridging
      exchangeVaultLoopbackAdapterV1Address: '', // TODO: katana staging address

      // TODO: katana vaults config (not initial release)
      fixedIncomeVaultProviderAddress: '',
      // profitShareVaultProviderAddress: '',
      fixedIncomeVaultProviderStateAggregatorAddress: '',
      fixedIncomeVaultMinInterestMultiplier: 0n,
      fixedIncomeVaultMaxInterestMultiplier: 1000000000n,
      fixedIncomeVaultMaxNetDeposits: 18446744073709551615n,
    },
    mantle: {
      chainId: 5001,
      chainNetwork: 'Mantle Testnet (not available)',
      chainCurrency: 'MNT',
      chainRpc: '#noRpc',
      chainRpcSoftwareWallet: true,
      chainBlockExplorer: '#notAvailable',
      depositPaused: true,
      depositNotAvailable: true,
      usdcTokenAddress: '0x123',
    },
    optimism: {
      chainNetwork: 'Optimism-Sepolia Testnet',
      chainBlockExplorer: 'https://sepolia-optimistic.etherscan.io',
      chainId: 11155420,
      chainCurrency: 'ETH',
      chainRpc: 'https://sepolia.optimism.io',
      chainRpcSoftwareWallet: true,
      depositPaused: true,
      usdcTokenAddress: '0x488327236B65C61A6c083e8d811a4E0D3d1D4268',
      preferredChain: true,
    },
    polygonPoS: {
      // Most likely not work as Mumbai is deprecated
      chainNetwork: 'Polygon-Mumbai Testnet',
      chainId: 80001,
      chainCurrency: 'POL',
      chainRpc:
        // https://polygon-amoy.g.alchemy.com/v2/xAMyz0EAIKlYUXnQOW4xvXZeh0PVF5QB
        'https://polygon-mumbai.g.alchemy.com/v2/AQvF7X06a70rZ133zHTSLh7Rqg6-_YeT',
      chainRpcSoftwareWallet: true,
      chainBlockExplorer: 'https://mumbai.polygonscan.com',
      depositNotAvailable: true,
      averageBlockTimeSec: 3,
      usdcTokenAddress: '0x742DfA5Aa70a8212857966D491D67B09Ce7D6ec7',
    },
    seiChain: {
      chainNetwork: 'Sei Testnet (Not setup)',
      chainId: 12345,
      chainCurrency: 'SEI',
      chainRpc: 'https://unknown',
      chainRpcSoftwareWallet: true,
      chainBlockExplorer: 'https://unknown',
      depositNotAvailable: true,
      averageBlockTimeSec: 1,
      depositPaused: true,
      usdcTokenAddress: '0xunknown',
    },
  },
} satisfies Config;

// Golden Config Sandbox v4
export const configSandbox = {
  ...sharedFields,
  intercomId: configProduction.intercomId,
  env: 'sandbox',
  envIsSandbox: true,
  turnstileCaptchaSiteKey: configProduction.turnstileCaptchaSiteKey,
  delegatedKeyExpirationDays: 30,
  chains: {
    ...configStaging.chains,
    katanaChain: {
      ...configStaging.chains.katanaChain,
      restApiUrl: 'https://api-perps-sandbox.katana.network/v1',
      webSocketApiUrl: 'wss://websocket-perps-sandbox.katana.network/v1',
      exchangeContract: '0x92d3072dDe1aD3e9B7895500F504aA5e664E71d3',
    },
  },
} satisfies Config;

// Kuma reward token 0x273c832797Bfda1C0826a786670D041282Bd6aFc

export const configDev = {
  ...sharedFields,
  widgetsSubdomain: false,
  intercomId: 'upnml9ft', // Test
  env: 'test',
  envIsSandbox: true,
  turnstileCaptchaSiteKey: configStaging.turnstileCaptchaSiteKey,
  delegatedKeyExpirationDays: 16,
  chains: {
    ...configStaging.chains,
    katanaChain: {
      ...configStaging.chains.katanaChain,
      restApiUrl: 'https://api-dev.katana-perps-dev.com/v1',
      webSocketApiUrl: 'wss://websocket-dev.katana-perps-dev.com/v1',
      exchangeContract: '0x38aBacC448795cB3c82Ff357947Fa81CAFAfcD1d',
      stargateAdapterV3Address: '0xC05b8DAAE57CC5b57Fece67c8b3a187ccA905bA0',
      exchangeVaultLoopbackAdapterV1Address: '',
    },
  },
} satisfies Config;

export const configLocalhost = {
  ...configDev,
  env: 'local', // 'local' | 'production',
  widgetsSubdomain: false,
  chains: {
    ...configDev.chains,
    katanaChain: {
      ...configDev.chains.katanaChain,
      restApiUrl: 'http://localhost:3001/v1',
      webSocketApiUrl: 'ws://localhost:9394/v1',
      chainRpc: 'http://localhost:3001/rpc',
      chainRpcSoftwareWallet: true,
    },
  },
} satisfies Config;

export const configLocalhostDev = {
  ...configStaging,
  env: 'local',
  chains: {
    ...configStaging.chains,
    katanaChain: {
      ...configStaging.chains.katanaChain,
      chainId: 1001,
      chainNetwork: 'Private Testnet',
      chainRpc: 'https://explorer-dev-geth.kuma-dev.com:8545',
      chainRpcSoftwareWallet: true,
      chainBlockExplorer: 'https://explorer-dev-geth.kuma-dev.com',
      webSocketApiUrl: 'ws://exchange-local.kuma-dev.com:9394/v1',
      restApiUrl: 'https://exchange-local-private.kuma-dev.com:3001/v1',
      // this should be overwritten based on your local env
    },
  },
} satisfies Config;
